/* eslint-disable */
<template>
  <div class="change-password p-0">
    <div class="red-vertical"></div>
    <div class="login-container">
      <div class="login-left">
        <div class="logo">
          <router-link :to="{ path: '/' }"><img src="@/assets/images/red_health_logo.svg"/></router-link>
        </div>
        <v-form ref="form" class="login-form">
          <v-subheader>Current Password</v-subheader>
          <v-text-field
            v-model="account.password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.validatePassword.required]"
            placeholder="Enter your Password"
            @click:append="() => (showPassword = !showPassword)"
            solo
            required
          ></v-text-field>

          <v-subheader>New Password</v-subheader>
          <v-text-field
            class="password-new-field"
            style="height: auto"
            v-model="account.newPassword"
            :type="showNewPassword ? 'text' : 'password'"
            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[
              rules.validateNewPassword.required,
              rules.validateNewPassword.notSameAsCurrent,
              rules.validateNewPassword.policy,
            ]"
            placeholder="Enter your new Password"
            @click:append="() => (showNewPassword = !showNewPassword)"
            solo
            required
          ></v-text-field>
          <div v-if="account.newPassword" class="mb-4 mt-n2 password-strength-wrap">
            <div style="margin-top: 5px" class="password-strength-meta">
              <span>Password strength</span>
              <span :class="newPasswordStrengthClass">{{ newPasswordStrength }}</span>
            </div>
            <v-progress-linear
              :value="newPasswordStrengthPercent"
              :color="newPasswordStrengthColor"
              background-color="#eceff1"
              height="8"
              rounded
            ></v-progress-linear>
          </div>

          <v-subheader>Re-Password</v-subheader>
          <v-text-field
            v-model="account.rePassword"
            :type="showRePassword ? 'text' : 'password'"
            :append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.validateRePassword.required, rules.validateRePassword.match]"
            placeholder="Re-Enter your new Password"
            @click:append="() => (showRePassword = !showRePassword)"
            solo
            required
          ></v-text-field>
          <br /><br />

          <div class="alert alert-success hidden-element">
            <a class="close" title="close">×</a>
            <b>Success:</b> {{ successMessage }}
          </div>
          <div class="alert alert-danger hidden-element">
            <a class="close" title="close">×</a>
            <b>Error:</b> {{ errorMessage }}
          </div>

          <div class="icon-group right-float-element">
            <v-btn class="white-button" dark @click="$router.go(-1)">Cancel</v-btn>
            <v-btn class="red-button" dark @click="update">Update</v-btn>
          </div>
        </v-form>
      </div>
      <div class="login-right">
        <div class="banner">
          <a class="img" target="_blank" :href="src">
            <img src="@/assets/images/banner.png" />
          </a>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import auth from '@/assets/js/cognitoAuth'
  import utilities from '@/assets/js/utilities'
  import { getPasswordPolicyErrors } from '@/assets/js/passwordPolicy'
  import Footer from '@/components/Footer'
  import {JS} from "aws-amplify";

  export default {
    name: 'ChangePassword',
    components: {
      Footer,
    },
    data() {
      return {
        src: '',
        successMessage: 'Password successfully changed.',
        errorMessage: 'Incorrect password.',

        showPassword: false,
        showNewPassword: false,
        showRePassword: false,

        account: {
          userName: '',
          password: '',
          newPassword: '',
          rePassword: '',
        },

        rules: {
          validatePassword: {
            required: (value) => !!value || 'Password is required.',
          },
          validateNewPassword: {
            required: (value) => !!value || 'New password is required.',
            notSameAsCurrent: (value) => {
              if (!value) return true
              return value !== this.account.password || 'New password is same as current password.'
            },
            policy: (value) => {
              if (!value) return true
              if (value === this.account.password) return true
              const errs = this.newPasswordPolicyErrors
              if (!errs.length) return true
              return (
                errs.map((e) => `${e}`).join('\n')
              )
            },
          },
          validateRePassword: {
            required: (value) => !!value || 'Re-password is required.',
            match: (value) => !(value != this.account.newPassword) || 'Re-password is incorrect.',
          },
        },
      }
    },
    computed: {
      newPasswordPolicyErrors() {
        return getPasswordPolicyErrors(this.account.newPassword)
      },
      newPasswordStrengthLevel() {
        const password = this.account.newPassword || ''
        if (!password) {
          return 0
        }
        if (this.newPasswordPolicyErrors.length > 0) {
          return 1
        }

        const hasRepeatedChars = /(.)\1{2,}/.test(password)
        const hasSequentialPattern = this.hasSequentialPattern(password)
        const hasKeyboardPattern = this.hasKeyboardPattern(password)
        const normalized = this.normalizeForCommonWordCheck(password)
        const hasCommonWordPattern = this.hasCommonWordPattern(normalized)

        const noObviousPattern =
          !hasRepeatedChars &&
          !hasSequentialPattern &&
          !hasKeyboardPattern &&
          !hasCommonWordPattern

        const uniqueCharRatio =
          new Set(password.toLowerCase().split('')).size / password.length

        if (noObviousPattern && uniqueCharRatio >= 0.65) {
          return 4
        }
        if (noObviousPattern) {
          return 3
        }
        return 2
      },
      newPasswordStrength() {
        const level = this.newPasswordStrengthLevel
        if (level <= 1) return 'Weak'
        if (level === 2) return 'Medium'
        if (level === 3) return 'Strong'
        return 'Very Strong'
      },
      newPasswordStrengthClass() {
        if (this.newPasswordStrengthLevel === 4) {
          return 'strength-very-strong'
        }
        if (this.newPasswordStrengthLevel === 3) {
          return 'strength-strong'
        }
        if (this.newPasswordStrengthLevel === 2) {
          return 'strength-medium'
        }
        return 'strength-weak'
      },
      newPasswordStrengthPercent() {
        if (!this.account.newPassword) {
          return 0
        }
        return this.newPasswordStrengthLevel * 25
      },
      newPasswordStrengthColor() {
        if (this.newPasswordStrengthLevel === 4) {
          return '#0b8043'
        }
        if (this.newPasswordStrengthLevel === 3) {
          return '#1e8e3e'
        }
        if (this.newPasswordStrengthLevel === 2) {
          return '#f29900'
        }
        return '#d93025'
      },
    },
    methods: {
      normalizeForCommonWordCheck(value) {
        const substitutions = {
          '0': 'o',
          '1': 'i',
          '3': 'e',
          '4': 'a',
          '5': 's',
          '7': 't',
          '@': 'a',
          '$': 's',
          '!': 'i',
        }
        return (value || '')
          .toLowerCase()
          .split('')
          .map((c) => substitutions[c] || c)
          .join('')
      },
      hasCommonWordPattern(normalizedPassword) {
        const commonWords = [
          'password',
          'welcome',
          'admin',
          'qwerty',
          'abc',
          'iloveyou',
          'letmein',
          'moonlight',
          'sunshine',
          'correcthorse',
          'battery',
        ]
        return commonWords.some((word) => normalizedPassword.includes(word))
      },
      hasKeyboardPattern(password) {
        const lower = (password || '').toLowerCase()
        const patterns = ['qwerty', 'asdfgh', 'zxcvbn']
        return patterns.some((pattern) => lower.includes(pattern))
      },
      hasSequentialPattern(password) {
        if (!password || password.length < 3) return false
        const chars = password.toLowerCase()
        let asc = 1
        let desc = 1
        for (let i = 1; i < chars.length; i += 1) {
          const diff = chars.charCodeAt(i) - chars.charCodeAt(i - 1)
          asc = diff === 1 ? asc + 1 : 1
          desc = diff === -1 ? desc + 1 : 1
          if (asc >= 3 || desc >= 3) {
            return true
          }
        }
        return false
      },
      async logout() {
        this.$store.dispatch('loading/setLoadComponent', true)
        utilities.clearStore()
        await auth.logout(() => {
          this.$store.dispatch("user/setAuthentication", utilities.initAuthentication())
          this.$store.dispatch('user/removeUser')
          setTimeout(() => {
            this.$router.push({ name: "login" }).catch(err => {})
            this.$store.dispatch('loading/setLoadComponent', false)
          }, 1000)
        }, 'PASSWORD_CHANGED')
      },
      async update() {

        if (!this.$refs.form.validate()) {
          return false
        }
        await this.$store.dispatch('loading/setLoadComponent', true)
        const pwdSHA = await utilities.logSha1(this.account.newPassword)
        const res1 = await fetch('https://api.pwnedpasswords.com/range/' + pwdSHA.substring(0, 5))

        const res = await res1.text()
        const formatRes = res.split('\r\n')
        const item = formatRes.find(item => item.indexOf(pwdSHA.substring(5)) > -1)
        if(item) {
          this.$notify({
            dangerouslyUseHTMLString: true,
            message: '<div class="alert-warning">' +
                '            <b>Warning:</b> Your new password has been seen ' + item.split(':')[1] + ' times before, please change it' +
                '          </div>',
          });
          await this.$store.dispatch('loading/setLoadComponent', false)
          return
        }

        var authenticationData = {
          Username: this.account.userName,
          Password: this.account.password,
          NewPassword: this.account.newPassword,
        }
        try {
          auth.changePassword(authenticationData).then(() => {
            this.$store.dispatch('loading/setLoadComponent', false)
            utilities.showAlert('.alert-success')
            setTimeout(() => {
              this.logout()
            }, 500)
          }).catch(e => {
            this.$store.dispatch('loading/setLoadComponent', false)
            utilities.showErrorMessage(JSON.stringify(e.message))
          })
        } catch (e) {
          this.$store.dispatch('loading/setLoadComponent', false)
          utilities.showErrorMessage(e)
        }
      },
    },
    async beforeMount() {
      var result = ''
      const { HeroImagePresignURL, HeroJumpLinkURL } = await utilities.getBannerImage()
      this.src = HeroJumpLinkURL
      await new Promise((resolve, reject) => {
        var reader = new FileReader()
        reader.onloadend = function() {
          result = reader.result
          resolve(true)
        }
        reader.onerror = (error) => {
          reject(error)
        }
        reader.readAsDataURL(HeroImagePresignURL)
      })
      $('.banner img').attr('src', result)
    },
    mounted() {
      $('.change-password form').on('keypress', (e) => {
        if (e.keyCode == 13) {
          this.update()
        }
      })
    },
  }
</script>

<style scoped>
  .password-strength-wrap {
    margin-bottom: 12px;
  }
  ::v-deep .v-text-field__details {
      min-height: 0;
    }

  ::v-deep .v-text-field__details .v-messages{
      min-height: 0;
    }


  .password-strength-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-bottom: 6px;
  }

  .strength-weak {
    color: #d93025;
  }

  .strength-medium {
    color: #f29900;
  }

  .strength-strong {
    color: #1e8e3e;
  }

  .strength-very-strong {
    color: #0b8043;
    font-weight: 600;
  }

  .password-new-field ::v-deep .v-messages__message {
    white-space: pre-line;
  }
</style>
